document.addEventListener("DOMContentLoaded", () => {

    const moveWriteReviewContent = () => {
        const contentSummary = document.querySelector(".okeReviews-reviewsAggregate-summary");
        const writeReview = document.querySelector(".okeReviews-reviewsWidget-header-controls");

        contentSummary.appendChild(writeReview);
    }

    const resetWriteReviewContent = () => {
        const contentHeader = document.querySelector(".okeReviews-reviewsWidget-header");
        const writeReview = document.querySelector(".okeReviews-reviewsWidget-header-controls");

        contentHeader.appendChild(writeReview);
    }

    const mediaQuery = window.matchMedia('(min-width: 767px)');

    function handleMediaChange(e) {
    if (e.matches) {
        moveWriteReviewContent()
    } else {
        resetWriteReviewContent()
    }
    }

    handleMediaChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaChange);

})